import Component from '@glimmer/component'
import reportingBlue from '@images/homeschool-ui-icons/reporting_blue.svg'
import reportingGreen from '@images/homeschool-ui-icons/reporting_green.svg'
import { SubscriptionType } from 'teacher-ui-client/subscription-type/subscription-types'
import HomeschoolBaseTile from 'teacher-ui-client/components/home/tiles/homeschool/base-tile'
import { t } from 'ember-intl'
import { TileButton } from 'teacher-ui-client/components/home/tiles/homeschool/button'
import { ThemeKeys } from 'teacher-ui-client/utils/themes'

interface Signature {
  Args: {
    subscriptionType: SubscriptionType.Reading | SubscriptionType.Maths
    uiScopeModels: unknown[]
  }
  Element: Element
}

export class ReportingTile extends Component<Signature> {
  get isMathsSubscription() {
    return this.args.subscriptionType === SubscriptionType.Maths
  }

  get isReadingSubscription() {
    return this.args.subscriptionType === SubscriptionType.Reading
  }

  <template>
    {{#if this.isMathsSubscription}}
      <HomeschoolBaseTile
        @themeKey={{ThemeKeys.green}}
        @imgSrc={{reportingBlue}}
        @imgAlt={{t "pages.home.panels.homeschool.reporting.imageAlt"}}
        @title={{t "pages.home.panels.homeschool.reporting.title"}}
        @tileDescription={{t "pages.home.panels.homeschool.reporting.description"}}
      >
        <div class="flex flex-col items-center space-y-4 text-center">
          <TileButton
            @title={{t "pages.home.panels.homeschool.reporting.buttonText.ms"}}
            @themeKey={{ThemeKeys.blue}}
            @route="reporting.ui-scope.maths.dashboard"
            @models={{@uiScopeModels}}
            data-test-homeschool-reporting-button-ms
          />
        </div>
      </HomeschoolBaseTile>

    {{else if this.isReadingSubscription}}
      <HomeschoolBaseTile
        @themeKey={{ThemeKeys.blue}}
        @imgSrc={{reportingGreen}}
        @imgAlt={{t "pages.home.panels.homeschool.reporting.imageAlt"}}
        @title={{t "pages.home.panels.homeschool.reporting.title"}}
        @tileDescription={{t "pages.home.panels.homeschool.reporting.description"}}
      >
        <div class="flex flex-col items-center space-y-4 text-center">
          <TileButton
            @title={{t "pages.home.panels.homeschool.reporting.buttonText.re"}}
            @themeKey={{ThemeKeys.blue}}
            @route="reporting.ui-scope.re.dashboard"
            @models={{@uiScopeModels}}
            data-test-homeschool-reporting-button-re
          />
          <TileButton
            @title={{t "pages.home.panels.homeschool.reporting.buttonText.rex"}}
            @themeKey={{ThemeKeys.purple}}
            @route="reporting.ui-scope.rex.dashboard"
            @models={{@uiScopeModels}}
            data-test-homeschool-reporting-button-rex
          />
          <TileButton
            @title={{t "pages.home.panels.homeschool.reporting.buttonText.fp"}}
            @themeKey={{ThemeKeys.pink}}
            @route="reporting.ui-scope.fast-phonics.dashboard"
            @models={{@uiScopeModels}}
            data-test-homeschool-reporting-button-fp
          />
        </div>
      </HomeschoolBaseTile>

    {{/if}}
  </template>
}

export default ReportingTile
